/* LAVISH: Produktbilder in Karten wischen (Startseite „Drop & Shop“).
   Klein und ohne Abhängigkeiten: Punkte mitführen, nächstes Bild erst bei Bedarf laden, Pfeile am Desktop.
   Die Kollektionsseite hat ihre eigene Logik (ai-lavish-collection.js) → dort wird nichts doppelt gemacht. */
(function () {
  if (window.__lvSwipe) return;
  window.__lvSwipe = true;

  function mine(el) { return el && !el.closest('[data-lvcol]'); }
  function preload(track, idx) {
    var imgs = track.querySelectorAll('img');
    for (var i = idx; i <= idx + 1 && i < imgs.length; i++) {
      if (imgs[i] && imgs[i].loading === 'lazy') imgs[i].loading = 'eager';
    }
  }
  function syncDots(track) {
    var w = track.clientWidth || 1;
    var idx = Math.round(track.scrollLeft / w);
    var media = track.closest('[data-lvg]');
    var dots = media && media.parentNode.querySelector('[data-lvg-dots]');
    if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === idx); });
    preload(track, idx + 1);
  }

  var tick = null;
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t.hasAttribute || !t.hasAttribute('data-lvg-track') || !mine(t)) return;
    if (tick) return;
    tick = requestAnimationFrame(function () { tick = null; syncDots(t); });
  }, { capture: true, passive: true });

  /* Erst beim Berühren/Drüberfahren das 2. Bild holen – spart Daten bei schwachem Netz */
  function warm(e) {
    var m = e.target.closest && e.target.closest('[data-lvg]');
    if (!mine(m) || m.__pre) return;
    m.__pre = true;
    var t = m.querySelector('[data-lvg-track]');
    if (t) preload(t, 1);
  }
  document.addEventListener('pointerdown', warm, { passive: true });
  document.addEventListener('mouseover', warm, { passive: true });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lvg-go]');
    if (!b || !mine(b)) return;
    e.preventDefault();
    var t = b.parentNode.querySelector('[data-lvg-track]');
    if (!t) return;
    var w = t.clientWidth, n = t.children.length;
    var idx = Math.round(t.scrollLeft / w) + parseInt(b.getAttribute('data-lvg-go'), 10);
    if (idx < 0) idx = n - 1;
    if (idx >= n) idx = 0;
    preload(t, idx);
    t.scrollTo({ left: idx * w, behavior: 'smooth' });
  });
})();
